import { axios } from '@Root/API'

export const createStudentCourseSession = payload => {
	return axios.post('student-engagement', payload)
}
